import { type TopIndependentStatus } from '#app/__generated__/api.js';
import { SelectMenu } from '#app/components/SelectMenu/SelectMenu.js';
import { TextField } from '#app/components/TextField/TextField.js';
import { useSelect } from 'downshift';

type TopIndependentStatusSelectProps = {
  readonly onSelection: (selection: TopIndependentStatus) => void;
  readonly selection: TopIndependentStatus;
};

const items: TopIndependentStatus[] = [
  'DISCOVERED',
  'OPTED_IN',
  'OPTED_OUT',
  'UNDISCOVERED',
];

export const TopIndependentStatusSelect = ({
  onSelection,
  selection,
}: TopIndependentStatusSelectProps) => {
  const {
    getItemProps,
    getMenuProps,
    getToggleButtonProps,
    highlightedIndex,
    isOpen,
    selectedItem: selectedStatus,
  } = useSelect<TopIndependentStatus>({
    initialSelectedItem: selection,
    items,
    onSelectedItemChange: ({ selectedItem }) => {
      if (selectedItem) {
        onSelection(selectedItem);
      }
    },
  });

  return (
    <TextField>
      <TextField.InputGroup
        as="button"
        type="button"
        {...getToggleButtonProps()}
      >
        <TextField.SelectionText>{selectedStatus}</TextField.SelectionText>
        <TextField.Chevron isOpen={isOpen} />
      </TextField.InputGroup>
      <TextField.Menu>
        <SelectMenu>
          <SelectMenu.Dialog {...getMenuProps()}>
            {isOpen && (
              <SelectMenu.List
                maxHeight="200px"
                overflowY="hidden"
              >
                {items.map((item, index) => {
                  return (
                    <SelectMenu.Item
                      isHighlighted={highlightedIndex === index}
                      key={item}
                      {...getItemProps({ index, item })}
                    >
                      {item}
                    </SelectMenu.Item>
                  );
                })}
              </SelectMenu.List>
            )}
          </SelectMenu.Dialog>
        </SelectMenu>
      </TextField.Menu>
    </TextField>
  );
};
